"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
$(document).ready(function () {
  function getSearchType() {
    var url = window.location.href.toLowerCase();
    if (url.includes('/search')) return 'global';
    if (url.includes('/find-a-doctor')) return 'find a clinician';
    if (url.includes('/find-a-location')) return 'location';
    if (url.includes('/patient-care')) return 'services';
    if (url.includes('/news-media/blog-search')) return 'blog';
    return '';
  }

  // PAGE VIEW EVENT
  var metaDescription = document.querySelector('meta[name="analytics-site-name"]');
  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push({
    'event': 'pageView',
    'siteName': metaDescription && metaDescription.content ? metaDescription.content : '',
    'pageReferrer': document.referrer ? document.referrer : '',
    'pageUrl': window.location.href,
    'pageTitle': document.title
  });

  // SITE SEARCH EVENT
  var lastSearchKey = '';
  Coveo.$('.CoveoSearchInterface').on('deferredQuerySuccess', function (e, args) {
    var searchParams = new URLSearchParams(window.location.hash);
    var rawSearchTerm = searchParams.get("#q");
    var postalCodeCity = searchParams.get("f:location");
    var searchType = getSearchType();
    var searchTerm = (rawSearchTerm || '').toLowerCase();
    var locationTerm = (postalCodeCity || '').toLowerCase();
    var currentSearchKey = "".concat(searchTerm, "|").concat(locationTerm);
    if ((searchTerm || locationTerm) && currentSearchKey !== lastSearchKey) {
      lastSearchKey = currentSearchKey;
      window.adobeDataLayer = window.adobeDataLayer || [];
      window.adobeDataLayer.push({
        event: 'siteSearch',
        searchTerm: searchTerm,
        searchType: searchType,
        postalCodeCity: locationTerm
      });
    }
  });
  var searchType = getSearchType();
  var previousStandardSelected = {};
  var firstStandardLoad = true;
  Coveo.$('.CoveoSearchInterface').on('deferredQuerySuccess', function (e, args) {
    var facets = args.results.facets || [];
    var hash = window.location.hash;
    var urlParams = new URLSearchParams(hash.replace(/^#/, '?'));
    var _iterator = _createForOfIteratorHelper(urlParams.entries()),
      _step;
    try {
      var _loop = function _loop() {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          if (!key.startsWith('f:')) return 0; // continue
          var field = key.substring(2).replace(/^@/, '');
          var lowerField = field.toLowerCase();
          var internalFieldsToIgnore = ['geolocation', 'location'];
          if (internalFieldsToIgnore.includes(lowerField)) return 0; // continue
          var category = lowerField;
          var facetBlocks = document.querySelectorAll('.CoveoFacet, .CoveoBooleanFacet, .CoveoDynamicFacet');
          facetBlocks.forEach(function (block) {
            var _block$dataset$id, _block$dataset$field;
            var domId = (_block$dataset$id = block.dataset.id) === null || _block$dataset$id === void 0 ? void 0 : _block$dataset$id.toLowerCase();
            var domField = (_block$dataset$field = block.dataset.field) === null || _block$dataset$field === void 0 ? void 0 : _block$dataset$field.replace(/^@/, '').toLowerCase();
            if (domId === lowerField || domField === lowerField) {
              var title = block.dataset.title;
              if (title) {
                category = title;
              }
            }
          });
          var selectedValues = [];
          try {
            selectedValues = JSON.parse(value);
          } catch (e) {
            selectedValues = value.replace(/^\[|\]$/g, '').split(',');
          }
          selectedValues = selectedValues.map(function (v) {
            return v === null || v === void 0 ? void 0 : v.toString().trim().replace(/^"|"$/g, '');
          });
          setTimeout(function () {
            var fieldMap = {
              affiliations: 'affiliationsdisplayname'
            };
            var mappedValues = selectedValues.map(function (rawVal) {
              var raw = rawVal === null || rawVal === void 0 ? void 0 : rawVal.toString().trim().replace(/^"|"$/g, '');
              var lowerField = field.toLowerCase();
              var effectiveField = fieldMap[lowerField] || lowerField;
              var facetBlock = Array.from(document.querySelectorAll('.CoveoFacet, .CoveoBooleanFacet, .CoveoDynamicFacet')).find(function (el) {
                var _el$dataset$field;
                var domField = (_el$dataset$field = el.dataset.field) === null || _el$dataset$field === void 0 ? void 0 : _el$dataset$field.replace(/^@/, '').toLowerCase();
                return domField === effectiveField;
              });
              if (facetBlock) {
                var _Array$from$find;
                var captionEl = facetBlock.querySelector(".coveo-facet-value-caption[data-original-value=\"".concat(raw, "\"]"));
                if (captionEl) {
                  var _captionEl$getAttribu;
                  return ((_captionEl$getAttribu = captionEl.getAttribute('title')) === null || _captionEl$getAttribu === void 0 ? void 0 : _captionEl$getAttribu.trim()) || captionEl.textContent.trim();
                }
                var dynamicEl = facetBlock.querySelector(".coveo-dynamic-facet-value[data-value=\"".concat(raw, "\"] .coveo-checkbox-span-label"));
                if (dynamicEl) {
                  var _dynamicEl$getAttribu;
                  return ((_dynamicEl$getAttribu = dynamicEl.getAttribute('title')) === null || _dynamicEl$getAttribu === void 0 ? void 0 : _dynamicEl$getAttribu.trim()) || dynamicEl.textContent.trim();
                }
                var boolLabel = (_Array$from$find = Array.from(facetBlock.querySelectorAll('.coveo-checkbox-label')).find(function (el) {
                  var _el$querySelector;
                  return ((_el$querySelector = el.querySelector('input')) === null || _el$querySelector === void 0 ? void 0 : _el$querySelector.value) === raw;
                })) === null || _Array$from$find === void 0 ? void 0 : _Array$from$find.querySelector('.coveo-checkbox-span-label');
                if (boolLabel) {
                  var _boolLabel$getAttribu;
                  return ((_boolLabel$getAttribu = boolLabel.getAttribute('title')) === null || _boolLabel$getAttribu === void 0 ? void 0 : _boolLabel$getAttribu.trim()) || boolLabel.textContent.trim();
                }
              }
              return raw;
            });
            var prev = previousStandardSelected[category] || [];
            var newSelected = firstStandardLoad ? mappedValues : mappedValues.filter(function (v) {
              return !prev.includes(v);
            });
            newSelected.forEach(function (val) {
              if (!val) return;
              window.adobeDataLayer = window.adobeDataLayer || [];
              window.adobeDataLayer.push({
                event: 'refinementApplied',
                category: category,
                detail: val.toLowerCase(),
                searchType: searchType
              });
            });
            previousStandardSelected[category] = mappedValues;
          }, 100);
        },
        _ret;
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    firstStandardLoad = false;
  });
  $('form.custom-form').each(function () {
    var $form = $(this);
    var formElement = this;
    var formViewed = false;
    var formInteracted = false;
    var isInvalidForm = false;
    var formId = $form.attr('id');
    if (formId !== "feedbackform") {
      var formObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !formViewed) {
            formViewed = true;
            observer.unobserve(formElement);
            window.adobeDataLayer = window.adobeDataLayer || [];
            window.adobeDataLayer.push({
              event: 'formView',
              formName: document.title,
              formId: formId
            });
          }
        });
      }, {});
      formObserver.observe(formElement);
      $form.one("input change", "input, textarea, select", function () {
        if (formInteracted) return;
        formInteracted = true;
        window.adobeDataLayer = window.adobeDataLayer || [];
        window.adobeDataLayer.push({
          event: 'formStart',
          formName: document.title,
          formId: formId
        });
      });
      $form.on('invalid-form', function () {
        isInvalidForm = true;
      });
      $form.on("submit", function (e) {
        setTimeout(function () {
          if (isInvalidForm) {
            isInvalidForm = false;
            return;
          }
          var email = $form.find('input[type="email"]').val();
          window.adobeDataLayer = window.adobeDataLayer || [];
          window.adobeDataLayer.push({
            event: 'formSubmit',
            formName: document.title,
            formId: formId,
            email: email
          });
        }, 500);
      });
    }
  });
});